module.exports = __webpack_public_path__ + "static/media/quality.c78113b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/quality.jpg
// module id = 802
// module chunks = 5